import React, { FC } from 'react';

import Rive, { Fit, Layout } from '@rive-app/react-canvas';
import clsx from 'clsx';

import styles from './styles.module.scss';

type Props = {
  isLoading?: boolean;
  className?: string;
  children?: React.ReactNode;
};

const Loader: FC<Props> = ({ className, isLoading = true, children }) => {
  return isLoading ? (
    <div className={styles.loader_wrapper}>
      <div className={clsx(styles.animation, className)}>
        <Rive
          layout={
            new Layout({
              fit: Fit.Cover,
            })
          }
          shouldResizeCanvasToContainer
          src="/animations/loader.riv"
        />
      </div>
    </div>
  ) : (
    <>{children}</>
  );
};

export default Loader;
